module.exports = __webpack_public_path__ + "img/step-customer-voice-slide-one-bg.c141a410.png";